var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _tspan;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarAh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "400px",
    height: "400px",
    viewBox: "0 0 200 200",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1007"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2773",
    cx: 100,
    cy: 113,
    r: 40,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2774",
    stopOpacity: 0.5,
    stopColor: "#ffe2d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2775",
    stopOpacity: 0,
    stopColor: "#ffd0bc",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2777",
    cx: 100,
    cy: 57,
    r: 36,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2778",
    stopOpacity: 0.5,
    stopColor: "#ffe2d6",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2779",
    stopOpacity: 0,
    stopColor: "#ffd0bc",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4661",
    cx: 100,
    cy: 100,
    r: 150,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-backs-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4662",
    stopOpacity: 0,
    stopColor: "#ecf0f1",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4663",
    stopOpacity: 1,
    stopColor: "#c6dce2",
    offset: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4664",
    stopOpacity: 0,
    stopColor: "#c6dce2",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5131",
    x1: 100,
    y1: 141,
    x2: 100,
    y2: 138,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5132",
    stopOpacity: 1,
    stopColor: "#f7c1aa",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5133",
    stopOpacity: 1,
    stopColor: "#f0b399",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5563",
    cx: -558.588,
    cy: -490.918,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 140.5478 120.3577)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5564",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5565",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5567",
    cx: -565.337,
    cy: -492.691,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 130.3774 136.3533)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5568",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5569",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5573",
    x1: 122.283,
    y1: 93.047,
    x2: 123.61,
    y2: 91.466,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5574",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5575",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5581",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5582",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5583",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5586",
    cx: -578.76,
    cy: -490.73,
    r: 84.646,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 192.4794 119.8404)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5587",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5588",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient5590",
    cx: -584.778,
    cy: -487.329,
    r: 84.644,
    gradientTransform: "matrix(0.0991 8.856325e-004 -0.0011 0.0991 182.3104 135.839)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5591",
    stopOpacity: 0.8,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5592",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5596",
    x1: 120.284,
    y1: 93.047,
    x2: 121.611,
    y2: 91.467,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5597",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5598",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5604",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5605",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5606",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5782",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientTransform: "matrix(1 0 0 1 -50 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5783",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5784",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5792",
    x1: 130,
    y1: 81,
    x2: 126,
    y2: 85,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5793",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5794",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5933",
    x1: 128,
    y1: 106,
    x2: 128,
    y2: 69,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5934",
    stopOpacity: 0.95,
    stopColor: "#26120b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5935",
    stopOpacity: 1,
    stopColor: "#26120b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5937",
    x1: 72,
    y1: 106,
    x2: 72,
    y2: 69,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5938",
    stopOpacity: 0.95,
    stopColor: "#26120b",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5939",
    stopOpacity: 1,
    stopColor: "#26120b",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient5961",
    x1: 100,
    y1: 110,
    x2: 100,
    y2: 73,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-glasses-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5962",
    stopOpacity: 0.6,
    stopColor: "#151124",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop5963",
    stopOpacity: 1,
    stopColor: "#151124",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient6002",
    x1: 99.98,
    y1: 171.27,
    x2: 99.98,
    y2: 136.351,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6003",
    stopOpacity: 0.8,
    stopColor: "#f0b399",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6004",
    stopOpacity: 1,
    stopColor: "#d17f5b",
    offset: 0.7
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6010",
    cx: 125.675,
    cy: 87.605,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4314 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6011",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6012",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6013",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6014",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6015",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6016",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6018",
    cx: 125.674,
    cy: 87.605,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5691 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6019",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6020",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6021",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6022",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6023",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6024",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6026",
    cx: 125.675,
    cy: 87.605,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4314 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6027",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6028",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6029",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6030",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6031",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6032",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6036",
    cx: 123.905,
    cy: 84.411,
    fx: 137.93,
    fy: 82.292,
    r: 18.705,
    gradientTransform: "matrix(0.9998 0.0208 0.0166 -0.7998 -49.1889 149.3472)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6037",
    stopOpacity: 1,
    stopColor: "#f0b399",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6038",
    stopOpacity: 0.3,
    stopColor: "#f0b399",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6039",
    stopOpacity: 0,
    stopColor: "#ffd0bc",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6041",
    cx: 69.404,
    cy: 106.952,
    r: 29.508,
    gradientTransform: "matrix(1.0322 -0.0541 0.0541 1.0322 -5.8927 5.4187)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6042",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6043",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6047",
    cx: 125.674,
    cy: 87.605,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5691 -6.6017)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6048",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6049",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6050",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6051",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6052",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6053",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6057",
    cx: 123.905,
    cy: 84.411,
    fx: 137.93,
    fy: 82.292,
    r: 18.705,
    gradientTransform: "matrix(-0.9998 0.0208 -0.0166 -0.7998 249.1889 149.3472)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6058",
    stopOpacity: 1,
    stopColor: "#f0b399",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6059",
    stopOpacity: 0.3,
    stopColor: "#f0b399",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6060",
    stopOpacity: 0,
    stopColor: "#ffd0bc",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient6062",
    cx: 69.404,
    cy: 106.952,
    r: 29.508,
    gradientTransform: "matrix(-1.0322 -0.0541 -0.0541 1.0322 205.8927 5.4187)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6063",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop6064",
    stopOpacity: 0.3,
    stopColor: "#000000",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanwrap",
    transform: "matrix(0.8499995000000001,0,0,0.8499995000000001,14.952490198676102,17.66052825719308)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5977",
    d: "M160 24.999H40c0 0-1 193.284-1 199h123L160 24.999z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2780",
    d: "M190.858 199.866c-6.008-10.158-13.474-11.973-19.628-13.936 -6.323-2.016-19.346-3.178-26.449-4.6 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "#ffd0bc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2781",
    d: "M121.442 167.843c2.495 10.929 18.165 13.698 26.293 15.325 21.909 4.379 33.772 5.134 42.297 19.539 2.903 4.916 5.459 15.864 5.962 24.153 1.835 0.291 0.531-17.432-5.136-26.994 -9.742-16.472-29.089-15.135-46.077-18.535C137.921 179.958 121.628 175.542 121.442 167.843L121.442 167.843zM78.558 167.843c-0.186 7.699-16.479 12.115-23.339 13.488 -16.988 3.4-36.335 2.063-46.077 18.535 -5.667 9.563-6.971 27.285-5.136 26.994 0.503-8.289 3.059-19.237 5.962-24.153 8.524-14.405 20.388-15.16 42.297-19.539C60.393 181.541 76.063 178.771 78.558 167.843L78.558 167.843z",
    fill: "#ffe2d6",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2782",
    d: "M51.206 189.513c0 0 28.641 0.299 33.473 1.885 2.314 0.758 8.372 5.633 8.372 5.633s-6.556-3.17-8.658-3.758C79.51 191.909 51.206 189.513 51.206 189.513zM99.795 199.999c2.053-0.041 7.887-3.799 7.887-3.799s-5.574 2.059-7.342 2.16c-1.491 0.086-6.366-1.238-6.366-1.238S98.112 200.032 99.795 199.999zM117.008 192.757c6.75-1.818 29.786-3.23 29.786-3.23s-23.791-0.516-30.51 1.725c-2.252 0.752-7.562 5.16-7.562 5.16S114.786 193.354 117.008 192.757z",
    fill: "#f0b399",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2783",
    d: "M190.858 199.866c-9.741-16.471-29.122-15.142-46.077-18.535 -6.86-1.373-23.153-5.789-23.339-13.488 -0.192-8.066 4.291-40.09 4.291-40.09H74.005c0 0 4.487 32.023 4.294 40.09 -0.184 7.699-16.48 12.115-23.341 13.488 -7.104 1.422-20.125 2.584-26.448 4.6 -6.156 1.963-13.624 3.777-19.632 13.936 -3.644 6.16-6.008 16.133-6.008 27.133h194C196.869 215.999 194.509 206.026 190.858 199.866z",
    fill: "none",
    stroke: "#d17f5b",
    strokeWidth: 1.5,
    opacity: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6001",
    d: "M90.469 169.769c4.474 1.646 14.594 1.646 19.067 0 3.511-1.291 7.479-4.019 11.489-7.484 0.785-10.522 3.279-28.936 3.919-33.578 -1.113-0.109-2.256-0.21-3.428-0.303H78.609c-1.305 0.103-2.578 0.216-3.811 0.339 0.643 4.663 3.096 22.765 3.899 33.297C82.804 165.622 86.875 168.447 90.469 169.769z",
    fill: "url(#SvgjsLinearGradient6002)",
    opacity: 1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5986",
    d: "M145.471 178.022c-1.061 15.897 0.707 33.905 0.707 33.905 -7.768-3.362-22.639-15.503-26.666-16.49 -4.061 2.169-6.393 2.106-7.4 2.359 -5.947 0.997-13.61 2.537-20.636-1.041 -1.868 0.035-3.905 0.708-5.905 2.207 -12.993 9.737-21.868 10.612-28.634 15.292 1.635-27.44-0.969-27.127-1.584-36.505 -1.19-0.449-1.364-0.623-1.995-1.753 -10.244 3.183-30.212 6.022-40.19 15.947 -8.894 8.844-11.768 22.784-10.309 35.422 54.74-0.592 138.876-1.306 193.888-0.761C197.551 186.068 175.945 185.906 145.471 178.022z",
    fill: "#1961e0",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5987",
    d: "M119.089 197.568c-2.052-0.513-3.667-0.068-5.207-0.069 1.284-0.237 3.127-0.725 5.63-2.062 3.544 0.869 18.16 11.9 26.269 16.461C136.602 209.54 127.018 200 119.089 197.568zM94.757 198.053c-1.103-0.329-2.201-0.746-3.282-1.297 -1.868 0.035-3.905 0.708-5.905 2.207 -10.305 7.723-21.76 12.23-27.887 15.123C88.137 205.707 83.056 198.188 94.757 198.053z",
    fill: "#024dd1",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5988",
    d: "M53.455 176.17C24.339 183.745-1.083 196.935 3 227.364c-0.047 0.001-0.096 0.002-0.143 0.002 -0.554-4.797-0.479-9.78 0.308-14.603 1.287-7.883 4.483-15.332 10.001-20.819 9.978-9.925 29.946-12.765 40.19-15.947C53.392 176.062 53.422 176.111 53.455 176.17zM145.471 178.022c-0.009 0.125-0.016 0.251-0.023 0.376 23.922 8.212 47.547 10.712 50.868 48.203 0.142 0.001 0.29 0.003 0.431 0.004C197.551 186.068 179.202 186.402 145.471 178.022z",
    fill: "#3377ef",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5989",
    d: "M197.279 226.896c0 0-28.002 0.37-46.59 0.479 -12.59 0.08-25.181 0.15-37.771 0.2 -81.177 0.293-83.75-0.07-110.65-0.07 0 0-0.465-2.604-0.57-5.159 -1.659-40.352 30.275-40.577 51.729-46.788 0.274-0.079 0.565 0.04 0.704 0.29 0.333 0.6 0.916 1.025 1.106 1.12 0.01 0.33 0.03 0.65 0.05 0.979 -0.794-0.299-0.91-0.445-1.815-1.385 -0.084-0.087-0.178-0.162-0.292-0.121 -1.901 0.687-4.172 0.994-6.172 1.624 4.455 6.695 4.095 7.949 10.01 14.95 0.008 0.088 0.07 1.313 0.08 1.83 -5.761-5.881-7.017-9.274-11.08-16.48 -16.972 5.388-33.363 6.301-40.88 27.08 -2.474 6.846-2.944 14.967-2.15 21.98 59.171-0.638 134.022-1.259 193.7-0.761 0.3-14.363-3.066-30.22-15.511-37.189 -4.957-2.779-9.965-3.909-28.04-9 -1.481 3.65-5.049 8.293-7.789 11.17 -0.021-0.59-0.04-1.19-0.051-1.78 1.498-1.947 5.708-7.463 6.71-9.71 -2.14-0.6-4.27-1.21-6.399-1.84 0-0.28 0-0.55 0-0.82 7.963 1.854 28.813 6.277 35.64 9.931C195.5 195.033 199.143 211.619 197.279 226.896zM119.6 195.686c-0.221-0.09-0.44-0.15-0.66-0.181 -2.352 0.574-3.164 1.221-7.11 2 -3.127 0.617-10.333 1.927-17.07 0.211 0.036 0.098 0 0 0 0 -1.023-0.566-2.024-0.729-3.24-0.7C99.242 201.4 113.793 198.262 119.6 195.686zM130.699 202.775c-0.271-0.19-0.53-0.38-0.79-0.58 -17.37 8.853-32.546 8.652-50.1 4.74 -1.11-0.29-2.21-0.61-3.3-0.95 -0.34 0.18-0.69 0.36-1.05 0.52C93.449 213.814 114.174 212.888 130.699 202.775z",
    fill: "#0040b2",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5990",
    d: "M56.979 214.415c1.692-28.206-2.607-30.744-1.55-42.351 3.373-1.974 6.717-2.578 8.406-4.544 8.052-9.419 7.112-13.441 12.346-15.903 1.041 4.357 1.672 14.578 1.678 14.713 3.949 11.71 6.64 16.713 9.878 21.422 1.879 2.727 5.893 6.911 6.854 9.761 -1.93-0.97-5.274-0.973-8.979 1.61 -6.009 4.147-3.838 5.138-16.357 9.679C64.814 210.398 60.982 212.567 56.979 214.415zM145.199 189.736c-0.004-0.288 0.321-14.813 0.357-16.021 -6.442-2.361-13.296-20.229-22.095-21.438 -2.597 16.247 0.486 10.404-7.249 30.08 -1.912 4.86-2.634 6.697-2.988 14.756 0.197-0.053 0.541-0.146 0.557-0.146l0 0c2.67-0.704 3.561-1.123 5.178-1.56 0.83 0.169 2.208 0.877 2.463 1.081l-0.006-0.011c7.472 3.991 14.442 11.187 24.802 15.61C146.427 208.185 145.199 198.497 145.199 189.736z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5991",
    d: "M114.866 196.669c-0.33 0.094-0.683 0.191-1.085 0.298 -0.016 0-0.359 0.093-0.557 0.146 0.354-8.059 1.076-9.896 2.988-14.756 7.735-19.676 4.652-13.833 7.249-30.08 1.764 0.242 3.448 1.283 5.068 2.799 -1.115 8.624-3.485 15.436-6.941 23.212 4.048-2.29 8.441-5.093 12.411-7.287C125.745 178.43 117.495 185.863 114.866 196.669zM94.591 197.513c-0.961-2.85-4.976-7.034-6.854-9.761 -3.238-4.709-5.929-9.712-9.878-21.422 -0.006-0.135-0.638-10.355-1.678-14.713 -3.31 1.557-3.032 2.683-5.24 6.458 1.777 9.193 5.37 15.037 10.465 22.681C77.063 177.893 71 173 65 170c10.107 7.58 17.375 17.29 24.197 27.335C91.411 196.658 93.313 196.87 94.591 197.513z",
    fill: "#dedbd4",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5992",
    d: "M87.819 187.695c-4.936-7.178-7.181-13.699-9.86-21.37 0 0-0.438-10.561-1.51-14.85 -5.393 2.474-4.59 5.505-12.69 14.979 -2.291 2.666-5.4 3.784-8.43 5.601 -0.777 8.533 1.619 15.055 1.77 22.79 0.218 5.698 0.193 12.783-0.23 19.729 4.04-1.853 7.922-4.063 12.42-5.68 12.532-4.546 10.38-5.548 16.38-9.69 3.873-2.699 7.279-2.524 9.09-1.489C93.939 194.836 89.754 190.504 87.819 187.695zM74.019 205.915c-7.949 3.13-5.769 1.673-16.68 7.931 3.049-21.622-1.58-31.625-1.58-41.37 3.139-1.624 6.156-2.509 8.47-5.16 8.667-9.967 6.861-12.405 11.66-15.34 0.3 2.859 0.54 5.74 0.69 8.63 0.512 10.227-0.853 3.241 3.17 13.78 5.946 15.57 11.621 17.19 14.31 22.569C86.424 193.63 80.99 203.591 74.019 205.915zM145.299 189.735c-0.005-0.397 0.353-16.004 0.36-16.09 -6.451-2.231-13.624-20.399-22.579-21.48 -0.757 4.655-1.651 14.73-1.651 14.73 -6.107 20.451-7.73 16.906-8.31 30.35 0.003 0 0.646-0.179 0.688-0.182 2.547-0.672 3.516-1.094 5.133-1.559 0.254 0.052 0.671 0.179 0.92 0.29 0.032 0.016 1.544 0.762 1.51 0.771 7.519 4.019 14.47 11.234 24.94 15.67C146.558 208.415 145.299 198.592 145.299 189.735zM139.089 207.216c-7.011-4.202-11.864-9.296-19.3-12.33 -2.013-0.85-4.606 0.879-6.38 2.18 0.979-8.548 0.644-6.609 2.46-11.521 8.37-22.729 6.028-9.863 7.99-32.89 7.676 2.56 14.698 19.021 20.99 21.05 -2.021 23.913 0.69 32.396 1.01 37.82C143.52 210.266 141.359 208.575 139.089 207.216z",
    fill: "#afa9a0",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left-move",
    transform: "matrix(1,0,0,1,0,0)",
    style: {}
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5994",
    d: "M47.001 83.974c-1.376-2.313-5.638-7.997-9.98-6.603 -2.749 0.882-3.293 3.765-3.735 6.311 -0.588 3.386 0.471 10.083 1.389 12.503 0.881 2.325 3.533 6.816 5.264 8.527 2.13 2.1 4.775 8.793 5.194 9.487 0.66 1.097 1.536 2.745 4.122 2.538 2.853-0.229 4.584-1.742 5.856-1.999C58.253 114.109 50.582 89.995 47.001 83.974z",
    fill: "#ffd0bc",
    stroke: "#d17f5b",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5995",
    d: "M44.197 97.997c-0.132-0.548 0.007-1.47 0.142-2.362 0.124-0.812 0.24-1.579 0.169-2.121 -0.267-2.032-1.773-5.893-2.757-7.985 -1.132-2.407-2.963-5.439-5.262-6.221 -0.95-0.324-1.575 0.063-1.938 0.456 -0.266 0.289-0.325 0.627-0.238 0.667 0.086 0.04 0.285-0.24 0.572-0.504 0.235-0.216 0.579-0.402 1.051-0.363 -0.19 1.011-1.167 6.49-0.744 10.225 0.333 2.938 1.593 5.131 1.79 5.46 0.029 0.346 0.077 0.685 0.148 1.014 0.929 4.287 4.971 9.163 6.378 10.758 0.259 0.295 0.531 0.47 0.598 0.398 0.066-0.072-0.094-0.364-0.353-0.66 -1.388-1.585-5.391-6.442-6.289-10.579 -0.952-4.389 2.318-10.896 3.048-12.272 0.371 0.646 0.687 1.267 0.93 1.785 0.19 0.406 0.402 0.881 0.619 1.395 -0.429 0.718-3.434 5.958-2.338 10.153 0.406 1.546 2.235 3.54 3.447 4.086 0.667 0.301 0.919 0.75 1.209 1.271 0.336 0.604 0.718 1.288 1.828 1.784 0.225 0.102 0.429 0.142 0.61 0.142 0.313 0 0.551-0.126 0.725-0.276 0.018 0.266 0.017 0.604 0.009 0.917 -0.012 0.404 0.042 0.737 0.137 0.745 0.094 0.008 0.196-0.313 0.207-0.717 0.016-0.496 0.013-1.11-0.072-1.403 -0.248-0.865-1.008-1.841-1.813-2.875C45.221 99.896 44.403 98.844 44.197 97.997zM36.95 94.196c-2.177-6.731 0.656-12.54 1.144-13.464 0.85 0.775 1.6 1.811 2.21 2.824C39.86 84.365 37.041 89.669 36.95 94.196zM46.341 104.042c-1.004-0.447-1.339-1.051-1.666-1.633 -0.293-0.527-0.598-1.072-1.369-1.42 -0.168-0.075-0.352-0.191-0.542-0.323 -2.486-5.906 0.272-8.488 0.963-9.017 0.211 0.722 0.369 1.384 0.439 1.915 0.063 0.488-0.052 1.263-0.167 2.012 -0.142 0.929-0.286 1.89-0.137 2.512 0.226 0.926 1.069 2.009 1.884 3.057 0.723 0.929 1.466 1.888 1.721 2.67C47.359 103.972 47.017 104.345 46.341 104.042z",
    fill: "#d17f5b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right-move",
    transform: "matrix(1,0,0,1,0,0)",
    style: {}
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5996",
    d: "M152.736 83.974c1.377-2.313 5.639-7.997 9.98-6.603 2.75 0.882 3.293 3.765 3.736 6.311 0.588 3.386-0.471 10.083-1.389 12.503 -0.881 2.325-3.533 6.816-5.266 8.527 -2.129 2.1-4.775 8.793-5.193 9.487 -0.658 1.097-1.535 2.745-4.121 2.538 -2.854-0.229-4.584-1.742-5.857-1.999C141.484 114.109 149.156 89.995 152.736 83.974z",
    fill: "#ffd0bc",
    stroke: "#d17f5b",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5997",
    d: "M153.727 100.913c-0.805 1.033-1.564 2.009-1.813 2.875 -0.086 0.293-0.088 0.907-0.072 1.403 0.012 0.404 0.113 0.725 0.207 0.717s0.148-0.341 0.137-0.745c-0.008-0.313-0.008-0.651 0.01-0.917 0.174 0.15 0.412 0.276 0.725 0.276 0.182 0 0.385-0.04 0.609-0.142 1.109-0.496 1.492-1.18 1.828-1.784 0.289-0.52 0.543-0.969 1.209-1.271 1.213-0.546 3.041-2.54 3.447-4.086 1.096-4.194-1.908-9.435-2.338-10.153 0.217-0.513 0.43-0.988 0.619-1.395 0.244-0.518 0.559-1.139 0.93-1.785 0.73 1.377 4 7.883 3.049 12.272 -0.896 4.137-4.9 8.994-6.289 10.579 -0.258 0.296-0.418 0.588-0.352 0.66 0.066 0.071 0.338-0.104 0.598-0.398 1.406-1.596 5.449-6.471 6.379-10.758 0.07-0.329 0.117-0.668 0.146-1.014 0.197-0.329 1.459-2.523 1.791-5.46 0.422-3.735-0.555-9.214-0.744-10.225 0.473-0.039 0.814 0.146 1.051 0.363 0.287 0.264 0.486 0.544 0.572 0.504s0.027-0.378-0.238-0.667c-0.363-0.393-0.988-0.779-1.938-0.456 -2.299 0.782-4.131 3.814-5.262 6.221 -0.984 2.093-2.49 5.953-2.758 7.985 -0.072 0.542 0.045 1.309 0.17 2.121 0.135 0.892 0.273 1.814 0.141 2.362C155.336 98.844 154.518 99.896 153.727 100.913zM159.434 83.555c0.611-1.013 1.361-2.049 2.211-2.824 0.488 0.925 3.32 6.733 1.145 13.464C162.697 89.669 159.879 84.365 159.434 83.555zM152.27 103.816c0.254-0.782 0.998-1.741 1.721-2.67 0.816-1.048 1.658-2.131 1.885-3.057 0.148-0.622 0.004-1.583-0.137-2.512 -0.115-0.749-0.23-1.524-0.166-2.012 0.068-0.531 0.227-1.193 0.438-1.915 0.691 0.529 3.449 3.111 0.965 9.017 -0.191 0.132-0.375 0.248-0.543 0.323 -0.771 0.348-1.074 0.893-1.369 1.42 -0.326 0.582-0.662 1.186-1.666 1.633C152.721 104.345 152.379 103.972 152.27 103.816z",
    fill: "#d17f5b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5998",
    d: "M144.004 125.052c-6.87 10.737-23.072 30.026-34.468 34.218 -4.474 1.646-14.594 1.646-19.067 0 -11.396-4.192-27.596-23.481-34.467-34.218 -6.753-10.551-14.852-47.803-14.863-47.856 -1.3-4.912-1.996-10.066-2.004-15.382C39.082 28.339 66.289 1.168 99.907 1.116c33.621-0.052 60.913 27.032 60.963 60.506 0.009 5.316-0.669 10.473-1.952 15.389C158.901 77.063 150.78 114.46 144.004 125.052z",
    fill: "#ffd0bc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5999",
    d: "M110.152 1.969c26.994 6.24 47.097 30.337 47.052 59.111 -0.009 5.315-0.704 10.471-2.004 15.382 -0.012 0.053-7.377 37.307-14.13 47.856 -6.872 10.735-22.339 29.292-33.734 33.484 -1.476 0.544-5.027 1.092-7.334 1.092 -2.307 0-5.857-0.548-7.333-1.092 -11.396-4.192-26.863-22.749-33.734-33.484 -6.753-10.55-14.119-47.803-14.13-47.856 -1.3-4.911-1.996-10.066-2.004-15.382C42.756 32.307 62.857 8.209 89.853 1.969 61.03 6.788 39.087 31.751 39.134 61.813c0.008 5.315 0.704 10.47 2.004 15.382 0.012 0.053 8.11 37.306 14.863 47.856 6.871 10.736 23.072 30.025 34.467 34.218 2.239 0.824 5.889 1.235 9.537 1.232 3.646 0.001 7.292-0.408 9.53-1.232 11.396-4.192 27.596-23.481 34.468-34.218 6.753-10.551 14.852-47.803 14.862-47.856 1.3-4.912 1.996-10.066 2.004-15.382C160.918 31.751 138.975 6.788 110.152 1.969z",
    fill: "#f7c1aa",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6000",
    d: "M144.004 125.052c-6.87 10.737-23.072 30.026-34.468 34.218 -4.474 1.646-14.594 1.646-19.067 0 -11.396-4.192-27.596-23.481-34.467-34.218 -6.753-10.551-14.852-47.803-14.863-47.856 -1.3-4.912-1.996-10.066-2.004-15.382C39.082 28.339 66.289 1.168 99.907 1.116c33.621-0.052 60.913 27.032 60.963 60.506 0.009 5.316-0.669 10.473-1.952 15.389C158.901 77.063 150.78 114.46 144.004 125.052z",
    fill: "none",
    stroke: "#d17f5b",
    strokeWidth: 1.5,
    opacity: 1
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single",
    transform: "matrix(0.9999999,0,0,0.9999999,0.000010000303646506836,0.000013399954980286566)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5130",
    d: "M100.091 139.322c-4.952 0-6.142-3.033-6.142-3.033 6.246 2.316 11.836-0.124 11.836-0.124S104.446 139.322 100.091 139.322z",
    fill: "url(#SvgjsLinearGradient5131)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5134",
    d: "M85.595 129.671c2.677-0.132 7.545-1.077 10.096-0.988 1.319 0.046 2.63 0.953 4.007 1.242 0.958 0.202 3.935-1.1 4.915-1.162 2.572-0.162 7.409 0.744 9.771 0.92 0.13 0.011 0 0 0 0s-5.776 7.727-14.463 7.725C90.09 137.406 85.595 129.671 85.595 129.671S85.463 129.678 85.595 129.671z",
    fill: "#f771a9",
    stroke: "#e85391",
    strokeWidth: 0.75,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5135",
    d: "M114.739 129.405c-0.045-0.131-0.461-0.189-0.624-0.139 -0.3 0.094-0.663 0.521-1.313 0.686 -0.748 0.191-5.021 1.431-6.193 1.49 -2.365 0.118-4.438 0.943-6.76 0.938 -2.323-0.005-4.34-0.929-6.716-1.058 -1.18-0.065-5.194-1.216-5.947-1.4 -0.65-0.16-0.89-0.574-1.162-0.686 -0.189-0.077-0.652-0.02-0.743 0.105 -0.079 0.107 0.088 0.609 0.2 0.75 0.271 0.336 1.103 0.506 1.667 0.647 0.779 0.199 4.759 1.366 5.949 1.433 2.305 0.13 4.308 1.125 6.612 1.127 2.306 0.003 4.405-0.904 6.729-1.022 1.195-0.062 5.53-1.313 6.332-1.513 0.58-0.146 1.388-0.399 1.672-0.68C114.58 129.95 114.785 129.538 114.739 129.405z",
    fill: "#c92066",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5136",
    d: "M99.799 136.138c-3.914 0-7.707-1.246-10.289-3.693 1.36 0.19 2.83 0.207 4.269 0.403 1.773 0.242 3.429 0.921 5.248 1.034 1.968 0.125 3.916-0.495 5.886-0.841 1.644-0.289 4.21-1.067 5.742-1.302C107.729 133.982 103.577 136.138 99.799 136.138zM105.256 131.043c1.49-0.149 3.855-0.879 5.226-1.04 -1.406-0.413-3.829-0.279-5.576-0.441 -1.506-0.139-3.244 0.861-4.817 1.016 -1.774 0.175-2.94-1.233-4.607-1.369 -1.809-0.147-3.787 0.559-5.336 0.915 1.387 0.188 2.877 0.239 4.309 0.517 1.753 0.341 3.405 0.992 5.223 1.054C101.537 131.757 103.419 131.226 105.256 131.043z",
    fill: "#ff8ebd",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5137",
    d: "M105.695 133.406c-0.308 0.01-0.625 0.025-0.93 0.051 -0.351 0.028-0.668 0.069-0.961 0.123 -0.538 0.099-1.074 0.233-1.638 0.369 -0.888 0.216-1.726 0.392-2.662 0.391 -0.15 0-0.301-0.007-0.452-0.017 -0.764-0.055-1.521-0.217-2.191-0.412 -0.693-0.204-1.353-0.401-2.019-0.492 -0.128-0.017-0.259-0.029-0.387-0.042 -0.409-0.036-0.836-0.052-1.255-0.063 1.734 1.396 4.128 2.038 6.468 2.041C102.079 135.356 103.946 134.512 105.695 133.406z",
    fill: "#ffa8cc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6009",
    d: "M60.986 83.262c0.405-0.904 2.145-2.183 5.923-3.078 1.724-0.409 4.107-0.321 6.578-0.143 5.98 0.429 11.736 4.248 13.547 7.316 0.004 0 0.008 0 0.012 0 0.351 0.611 0.565 1.192 0.585 1.702 0.041 1.082-0.444 1.94-1.316 2.623 0.001-0.001 0.002-0.002 0.003-0.004 -2.256 1.847-8.541 2.244-12.319 2.213 -7.52-0.063-9.723-2.969-9.723-2.969 -0.938-1.243-2.008-2.639-2.695-4.086 0.018 0.023 0.028 0.036 0.028 0.036 -0.715-1.591-0.636-2.143-0.719-3.156C60.904 83.566 60.938 83.414 60.986 83.262z",
    fill: "url(#SvgjsRadialGradient6010)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "matrix(1,0,0,1,-0.75,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6067",
    d: "M83.199 89.25c-1.231 4.522-5.896 7.187-10.429 5.944 -4.528-1.241-7.203-5.918-5.97-10.442 1.23-4.526 5.905-7.19 10.434-5.947C81.761 80.045 84.433 84.723 83.199 89.25z",
    fill: "#1c1919",
    stroke: "#000000",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6068",
    d: "M82.994 87.526c-0.625 5.021-4.353 7.638-8.432 7.365 -3.765-0.253-7.131-3.031-7.443-7.828 1.302-0.374 3.031 0.234 4.549 0.002 -0.005 0.055-0.023 0.104-0.025 0.16 -0.12 1.842 1.357 3.446 3.299 3.577 1.946 0.13 3.62-1.263 3.74-3.104 0.013-0.24-0.002-0.476-0.038-0.702C79.997 87.2 81.648 86.999 82.994 87.526z",
    fill: "#2b2b2b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6069",
    d: "M76.229 84.164c-1.869-0.535-3.777 0.533-4.26 2.396 -0.483 1.853 0.642 3.793 2.51 4.329 1.873 0.537 3.781-0.532 4.266-2.386C79.23 86.639 78.101 84.7 76.229 84.164z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6070",
    d: "M76.229 84.164c-1.869-0.535-3.777 0.533-4.26 2.396 -0.483 1.853 0.642 3.793 2.51 4.329 1.873 0.537 3.781-0.532 4.266-2.386C79.23 86.639 78.101 84.7 76.229 84.164z",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6071",
    d: "M70.977 92.181c-0.177 0.619-1.142 0.356-0.965-0.266 0.171-0.6 0.633-0.967 0.926-1.495 0.313-0.564 1.177-0.06 0.863 0.505C71.56 91.36 71.114 91.696 70.977 92.181L70.977 92.181zM72.516 91.194c-0.266 0.31-0.614 1.458-0.766 1.834 -0.241 0.598 0.727 0.856 0.965 0.266 0.082-0.205 0.362-1.223 0.508-1.393C73.64 91.415 72.936 90.704 72.516 91.194L72.516 91.194zM74.598 94.151c0.522-0.602 0.47-1.292 0.459-2.041 -0.01-0.644-1.01-0.645-1 0 0.006 0.415 0.13 0.992-0.166 1.334C73.47 93.929 74.175 94.639 74.598 94.151L74.598 94.151zM75.619 91.985c0.008 0.621 0.084 1.226 0.268 1.82 0.19 0.614 1.155 0.352 0.965-0.266 -0.159-0.513-0.226-1.019-0.232-1.555C76.611 91.341 75.611 91.34 75.619 91.985L75.619 91.985z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6072",
    d: "M80.946 85.543c-0.985 0.59-2.466 0.059-3.305-1.188 -0.838-1.248-0.713-2.739 0.273-3.328 0.984-0.593 2.467-0.061 3.301 1.187C82.053 83.462 81.932 84.952 80.946 85.543z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6034",
    d: "M56 88c0 13.808 8.06 24.999 18 24.999S92 101.808 92 88c0-13.809-8.06-25.001-18-25.001S56 74.191 56 88zM61.58 86.836c0.018 0.023 0.028 0.036 0.028 0.036 -0.715-1.591-0.636-2.143-0.719-3.156 0.015-0.149 0.048-0.301 0.097-0.454 0.405-0.904 2.145-2.183 5.923-3.078 1.724-0.409 4.107-0.321 6.578-0.143 5.98 0.429 11.736 4.248 13.547 7.316 0.004 0 0.008 0 0.012 0 0.351 0.611 0.565 1.192 0.585 1.702 0.041 1.082-0.444 1.94-1.316 2.623 0.001-0.001 0.002-0.002 0.003-0.004 -2.256 1.847-8.541 2.244-12.319 2.213 -7.52-0.063-9.723-2.969-9.723-2.969C63.337 89.679 62.268 88.283 61.58 86.836z",
    fill: "#ffd0bc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6035",
    d: "M57.143 85.081c0.027 8.284 8.484 14.962 18.902 14.919 10.414-0.047 18.836-6.796 18.813-15.08C94.83 76.635 86.371 69.957 75.955 70 65.539 70.047 57.119 76.796 57.143 85.081zM61.608 86.872c-0.715-1.591-0.636-2.143-0.719-3.156 0.015-0.149 0.048-0.301 0.097-0.454 0.405-0.904 2.145-2.183 5.923-3.078 1.724-0.409 4.107-0.321 6.578-0.143 5.98 0.429 11.736 4.248 13.547 7.316 0.004 0 0.008 0 0.012 0 0.351 0.611 0.565 1.192 0.585 1.702 0.041 1.082-0.444 1.94-1.316 2.623 0.001-0.001 0.002-0.002 0.003-0.004 -2.256 1.847-8.541 2.244-12.319 2.213 -7.52-0.063-9.723-2.969-9.723-2.969 -0.938-1.243-2.008-2.639-2.695-4.086C61.598 86.859 61.608 86.872 61.608 86.872z",
    fill: "url(#SvgjsRadialGradient6036)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6040",
    d: "M64.275 90.922c-0.938-1.243-2.008-2.639-2.695-4.086 0.018 0.023 0.028 0.036 0.028 0.036 -0.715-1.591-0.636-2.143-0.719-3.156 0.015-0.149 0.048-0.301 0.097-0.454 0.405-0.904 2.145-2.183 5.923-3.078 1.724-0.409 4.107-0.321 6.578-0.143 5.98 0.429 11.736 4.248 13.547 7.316 0.004 0 0.008 0 0.012 0 0.351 0.611 0.565 1.192 0.585 1.702 0.041 1.082-0.444 1.94-1.316 2.623 0.001-0.001 0.002-0.002 0.003-0.004 -2.256 1.847-8.541 2.244-12.319 2.213C66.479 93.828 64.275 90.922 64.275 90.922z",
    fill: "url(#SvgjsRadialGradient6041)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6044",
    d: "M88.256 84.111c-6.821-5.453-10.878-7.558-19.341-7.756 5.832-0.553 11.102 1.27 14.204 3.22C84.57 80.487 87.256 83.237 88.256 84.111z",
    fill: "#d17f5b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6045",
    d: "M73.998 93.782c3.778 0.031 10.063-0.36 12.319-2.179 -3.322 2.549-8.594 2.881-11.579 2.931 -1.947 0.032-5.992-0.08-7.732-0.953 -0.844-0.423-2.398-1.754-2.73-2.721C64.275 90.86 66.479 93.721 73.998 93.782zM60.151 79.638c-2.637 0.1-4.002-0.024-4.002-0.024 1.445 1.008 1.701 1.207 2.362 2.363 1.348 2.355 3.097 4.895 3.097 4.895 -0.715-1.567-0.636-2.11-0.719-3.107 -0.071-0.864 1.554-2.436 6.02-3.477 1.724-0.402 4.107-0.315 6.578-0.141 5.98 0.423 11.736 4.183 13.547 7.204 0.27-0.012 0.587-0.017 0.693-0.13 0.106-0.114 0.056-0.489-0.021-0.626 -2.488-4.434-11.123-9.373-18.236-9C64.524 77.854 61.992 79.568 60.151 79.638z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6017",
    d: "M139.014 83.262c-0.405-0.904-2.145-2.183-5.923-3.078 -1.724-0.409-4.107-0.321-6.578-0.143 -5.98 0.429-11.736 4.248-13.547 7.316 -0.004 0-0.008 0-0.012 0 -0.351 0.611-0.565 1.192-0.585 1.702 -0.041 1.082 0.444 1.94 1.316 2.623 -0.001-0.001-0.002-0.002-0.003-0.004 2.256 1.847 8.541 2.244 12.319 2.213 7.52-0.063 9.723-2.969 9.723-2.969 0.938-1.243 2.008-2.639 2.695-4.086 -0.018 0.023-0.028 0.036-0.028 0.036 0.715-1.591 0.636-2.143 0.719-3.156C139.096 83.566 139.063 83.414 139.014 83.262z",
    fill: "url(#SvgjsRadialGradient6018)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "matrix(1,0,0,1,0.75,0.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6073",
    d: "M133.199 89.25c-1.231 4.522-5.896 7.187-10.429 5.944 -4.528-1.241-7.203-5.918-5.97-10.442 1.23-4.526 5.905-7.19 10.434-5.947C131.761 80.045 134.433 84.723 133.199 89.25z",
    fill: "#1c1919",
    stroke: "#000000",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6074",
    d: "M132.994 87.526c-0.625 5.021-4.353 7.638-8.432 7.365 -3.765-0.253-7.131-3.031-7.443-7.828 1.302-0.374 3.031 0.234 4.549 0.002 -0.005 0.055-0.023 0.104-0.025 0.16 -0.12 1.842 1.357 3.446 3.299 3.577 1.946 0.13 3.62-1.263 3.74-3.104 0.013-0.24-0.002-0.476-0.038-0.702C129.997 87.2 131.648 86.999 132.994 87.526z",
    fill: "#2b2b2b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6075",
    d: "M126.229 84.164c-1.869-0.535-3.777 0.533-4.26 2.396 -0.483 1.853 0.642 3.793 2.51 4.329 1.873 0.537 3.781-0.532 4.266-2.386C129.23 86.639 128.101 84.7 126.229 84.164z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6076",
    d: "M126.229 84.164c-1.869-0.535-3.777 0.533-4.26 2.396 -0.483 1.853 0.642 3.793 2.51 4.329 1.873 0.537 3.781-0.532 4.266-2.386C129.23 86.639 128.101 84.7 126.229 84.164z",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 0.75,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6077",
    d: "M120.977 92.181c-0.177 0.619-1.142 0.356-0.965-0.266 0.171-0.6 0.633-0.967 0.926-1.495 0.313-0.564 1.177-0.06 0.863 0.505C121.56 91.36 121.114 91.696 120.977 92.181L120.977 92.181zM122.516 91.194c-0.266 0.31-0.614 1.458-0.766 1.834 -0.241 0.598 0.727 0.856 0.965 0.266 0.082-0.205 0.362-1.223 0.508-1.393C123.64 91.415 122.936 90.704 122.516 91.194L122.516 91.194zM124.598 94.151c0.522-0.602 0.47-1.292 0.459-2.041 -0.01-0.644-1.01-0.645-1 0 0.006 0.415 0.13 0.992-0.166 1.334C123.47 93.929 124.175 94.639 124.598 94.151L124.598 94.151zM125.619 91.985c0.008 0.621 0.084 1.226 0.268 1.82 0.19 0.614 1.155 0.352 0.965-0.266 -0.159-0.513-0.226-1.019-0.232-1.555C126.611 91.341 125.611 91.34 125.619 91.985L125.619 91.985z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6078",
    d: "M130.946 85.543c-0.985 0.59-2.466 0.059-3.305-1.188 -0.839-1.248-0.714-2.739 0.272-3.328 0.984-0.593 2.467-0.061 3.301 1.187C132.054 83.462 131.932 84.952 130.946 85.543z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6055",
    d: "M126 62.999c-9.94 0-18 11.193-18 25.001 0 13.808 8.06 24.999 18 24.999S144 101.808 144 88C144 74.191 135.94 62.999 126 62.999zM135.725 90.922c0 0-2.203 2.906-9.723 2.969 -3.778 0.031-10.063-0.366-12.319-2.213 0.001 0.001 0.002 0.002 0.003 0.004 -0.872-0.682-1.357-1.541-1.316-2.623 0.02-0.509 0.234-1.09 0.585-1.702 0.004 0 0.008 0 0.012 0 1.811-3.068 7.566-6.887 13.547-7.316 2.471-0.178 4.854-0.266 6.578 0.143 3.778 0.895 5.518 2.173 5.923 3.078 0.049 0.152 0.082 0.305 0.097 0.454 -0.083 1.013-0.004 1.565-0.719 3.156 0 0 0.011-0.013 0.028-0.036C137.732 88.283 136.663 89.679 135.725 90.922z",
    fill: "#ffd0bc",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6056",
    d: "M124.045 70c-10.416-0.043-18.875 6.635-18.902 14.92 -0.023 8.284 8.398 15.033 18.813 15.08 10.418 0.043 18.875-6.635 18.902-14.919C142.881 76.796 134.461 70.047 124.045 70zM138.42 86.836c-0.688 1.447-1.757 2.843-2.695 4.086 0 0-2.203 2.906-9.723 2.969 -3.778 0.031-10.063-0.366-12.319-2.213 0.001 0.001 0.002 0.002 0.003 0.004 -0.872-0.682-1.357-1.541-1.316-2.623 0.02-0.509 0.234-1.09 0.585-1.702 0.004 0 0.008 0 0.012 0 1.811-3.068 7.566-6.887 13.547-7.316 2.471-0.178 4.854-0.266 6.578 0.143 3.778 0.895 5.518 2.173 5.923 3.078 0.049 0.152 0.082 0.305 0.097 0.454 -0.083 1.013-0.004 1.565-0.719 3.156C138.392 86.872 138.402 86.859 138.42 86.836z",
    fill: "url(#SvgjsRadialGradient6057)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6061",
    d: "M135.725 90.922c0.938-1.243 2.008-2.639 2.695-4.086 -0.018 0.023-0.028 0.036-0.028 0.036 0.715-1.591 0.636-2.143 0.719-3.156 -0.015-0.149-0.048-0.301-0.097-0.454 -0.405-0.904-2.145-2.183-5.923-3.078 -1.724-0.409-4.107-0.321-6.578-0.143 -5.98 0.429-11.736 4.248-13.547 7.316 -0.004 0-0.008 0-0.012 0 -0.351 0.611-0.565 1.192-0.585 1.702 -0.041 1.082 0.444 1.94 1.316 2.623 -0.001-0.001-0.002-0.002-0.003-0.004 2.256 1.847 8.541 2.244 12.319 2.213C133.521 93.828 135.725 90.922 135.725 90.922z",
    fill: "url(#SvgjsRadialGradient6062)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6065",
    d: "M111.744 84.111c6.821-5.453 10.878-7.558 19.341-7.756 -5.832-0.553-11.102 1.27-14.204 3.22C115.43 80.487 112.744 83.237 111.744 84.111z",
    fill: "#d17f5b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6066",
    d: "M135.725 90.86c-0.332 0.966-1.887 2.297-2.73 2.721 -1.74 0.873-5.785 0.985-7.732 0.953 -2.985-0.049-8.257-0.381-11.579-2.931 2.256 1.819 8.541 2.21 12.319 2.179C133.521 93.721 135.725 90.86 135.725 90.86zM130.529 77.594c-7.113-0.373-15.748 4.565-18.236 9 -0.076 0.137-0.127 0.512-0.021 0.626 0.106 0.114 0.424 0.118 0.693 0.13 1.811-3.021 7.566-6.781 13.547-7.204 2.471-0.174 4.854-0.261 6.578 0.141 4.466 1.041 6.091 2.613 6.02 3.477 -0.083 0.997-0.004 1.541-0.719 3.107 0 0 1.749-2.54 3.097-4.895 0.661-1.156 0.917-1.355 2.362-2.363 0 0-1.365 0.124-4.002 0.024C138.008 79.568 135.476 77.854 130.529 77.594z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2772",
    d: "M140.204 113.007c0.035 22.275-17.995 40.365-40.273 40.396 -22.274 0.036-40.361-17.993-40.396-40.272C59.501 90.857 77.53 72.77 99.808 72.735 122.083 72.701 140.171 90.73 140.204 113.007z",
    fill: "url(#SvgjsRadialGradient2773)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2776",
    d: "M135,55.999c0,19.329-15.671,35-35,35c-19.329,0-35-15.671-35-35s15.671-35,35-35C119.329,20.999,135,36.67,135,55.999z",
    fill: "url(#SvgjsRadialGradient2777)",
    opacity: 1
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5857",
    d: "M56.113 70.739c32.178-9.407 39.48 9.836 32.802 3.849C81.977 68.368 65.958 68.92 56.113 70.739z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right-rotate",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5858",
    d: "M143.889 70.731c-9.304-1.701-22.773-2.38-30.946 2.53 -1.01 0.606-5.017 4.041-3.951 1.625C110.929 70.486 123.744 64.882 143.889 70.731z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5207",
    d: "M100.906,119.814c-0.402,0.434-0.73,0.381-1.108-0.07c0,0-4.82-3.077-4.208-4.488c0.967-2.233,9.735,0,9.735,0L100.906,119.814z",
    fill: "#f0b399",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5208",
    d: "M94.389,113.263c0,0,4.937-12.754,5.366-15.484c0.814,4.431-1.917,14.293-2.125,16.306c-0.251,2.444,2.645,5.497,2.645,5.497c0.238,0.544,0.062,0.682-0.395,0.313l-5.077-3.354C93.601,115.627,93.601,114.756,94.389,113.263z M102.579,115.924c0.7,0.143,0.847,0.395,0.793,0.655c-0.054,0.264-0.354,0.625-0.986,0.295c-0.695-0.36-2.005-0.525-2.005-0.525S101.879,115.78,102.579,115.924z",
    fill: "#d17f5b",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5979",
    d: "M44.483 18.786v192.7h39.633c-0.985-7.894-2.345-15.114-3.827-18.896 -7.734-19.635-34.67-24.746-29.979-50.592l0.186-0.036c5.161 11.272 7.599 17.786 19.622 19.774 -16.696-13.644-13.473-26.335-11.147-42.457 1.357-9.407-1.612-16.768-3.584-24.324 2.337-6.986 3.574-13.578 4.833-21.104C71.469 6.622 121.799 9.658 136.22 52.964c9.121 27.391 1.487 36.087 12.741 53.306 0.534 12.012 3.037 24.947-11.378 41.925 -3.168 3.731-7.858 7.637-11.999 10.247 15.048-1.334 23.306-15.722 28.299-29.979l0.183 0.058c-6.601 55.459-31.788 30.36-34.347 82.965h41.151v-192.7H44.483z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5980",
    d: "M84.239 24.512c0 0 13.507 2.744 15.441 8.394 -9.837-0.448-14.145-3.676-28.021 1.726C74.877 29.073 84.239 24.512 84.239 24.512zM116.354 23.835c0 0-14.886-0.596-16.673 9.07 9.837-0.448 15.855-4.834 29.83 1.466C127.59 28.832 116.354 23.835 116.354 23.835z",
    fill: "#0c080c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5981",
    d: "M171.325 103.155c12.474-84.818-28.429-117.88-66.57-108.483C62.686-15.575 30.577 5.914 25.649 64.39c-0.889 20.541 1.352 36.037 1.709 39.729 -2.823 5.811-4.602 12.117-5.334 18.632 -2.28 1.989-4.366 3.558-6.692 5.203 1.216-0.168 3.034-0.383 6.451-1.384 -0.802 22.784 10.506 26.852 9.795 45.72 -0.663 12.739-0.707 13.817 1.769 22.173 6.55 22.107-3.539 20.229-0.849 47.579 31.104-1.338 46.501 4.047 119.532-0.472 1.616-0.101 12.444-0.799 16.533-0.559 -16.247-55.787 11.274-50.916 2.58-79.354C163.35 136.169 184.674 127.674 171.325 103.155zM120.349 232.486c0.313 3.851 0.855 8.563 1.039 9.658 -14.026 0.059-13.942-0.431-36.432-0.219 0.397-13.065 1.519-40.587-1.77-48.975 -8.064-20.475-33.709-27.085-35.086-49.86l0.195-0.036c5.38 11.757 9.681 16.499 22.217 18.573 -17.408-14.226-13.83-25.25-13.383-42.226 0.265-9.903-1.679-17.482-3.736-25.362 2.437-7.282 3.738-14.154 5.041-22.003 5.299-31.981 23.306-56.507 41.03-39.238 0.001-0.001 0.225-0.316 0.225-0.316 0.096 0.134 0.084 0.114 0.202 0.302 15.169-16.919 29.792-2.734 37.781 17.474 11.073 27.991 1.55 37.627 13.281 55.582 0.56 12.526 1.191 25.365-13.838 43.069 -3.304 3.889-7.355 7.003-11.67 9.727 15.688-1.395 25.436-14.789 30.639-29.654l0.191 0.059C141.093 186.96 112.813 144.06 120.349 232.486z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5982",
    d: "M168.564 241.012c-4.089-0.24-14.917 0.458-16.533 0.559 -7.593 0.47-14.551 0.831-20.979 1.104 0.627-18.603-6.242-38.093 2.549-55.675 4.409-9.624 18.398-19 21.398-31 0.559-2.235 1.938-7.965 2.429-12.944 3.441 21.68-17.092 41.785-12.299 63.68 4.266-14.529 12.416-38.893 17.552-49.096 -0.563 16.096-1.812 20.566-1.289 30.668 4.13-9.095 7.526-16.68 5.584-38.498 0 0 2.598 6.715 4.168 11.848C179.839 190.096 152.317 185.225 168.564 241.012zM161.744 152.235c14.178-34.092-4.985-37.232-10.55-59.281C145.21 69.242 145.199 27.485 124 23c-10.773-2.279-19.332 1.04-24.926 9.434 0.13 0.122 0.26 0.239 0.39 0.366 0.001-0.001 0.225-0.316 0.225-0.316 0.096 0.134 0.084 0.114 0.202 0.302 15.169-16.919 29.792-2.734 37.781 17.474 11.073 27.991 1.55 37.627 13.281 55.582 2.666 23.645-7.074 41.159-25.508 52.796 15.263-7.068 28.199-18.51 30.174-46.749l0.398 0.199C161.471 119.218 164.952 140.731 161.744 152.235zM154.398 45c1.833 21.549 4.026 42.923 16.985 58.268 -0.021-0.038-0.038-0.074-0.059-0.112 0.178-1.207 0.604-4.451 0.76-5.638C166.309 90.678 160.708 78.757 159 66c-2.141-15.982 0.07-34.47-15.9-46C150.849 26.708 154.398 36 154.398 45zM69 18C44 33 50.146 61.473 44.146 84c-3.188 11.97-11.551 22.788-20.646 30.744 -0.609 2.384-1.069 4.813-1.377 7.277C60.299 97.473 45.24 48.478 61.199 30.666c11.568-12.911 25.383-17.769 38.489 1.817C96.415 16.706 79 13 69 18zM82.258 25.4c-7.133 1.456-14.761 9.231-18.923 16.342 -6.467 11.048-7.485 28.27-12.653 46.717 -4.4 15.707-13.998 30.571-33.68 39.249 26.759-5.687 35.423-30.752 36.391-33.667 2.437-7.282 3.738-14.154 5.041-22.003 5.26-31.746 23.042-56.139 40.64-39.604C93.415 26.512 90.127 23.793 82.258 25.4zM68.733 161.296c0.579 0.115 1.161 0.229 1.779 0.332 -17.408-14.226-14.13-25.25-13.683-42.226 0.255-9.563-1.65-17.359-3.626-24.951 -0.523 1.394-1.105 2.744-1.716 4.073C60.569 121.579 41.722 142.818 68.733 161.296zM146.702 161.628c9.171-9.346 13.167-29.969 11.369-43.484 -0.817 4.008-1.474 8.073-2.426 12.056 0.149-0.404 0.296-0.81 0.438-1.217l0.191 0.059c-15.183 57.919-43.463 15.019-35.927 103.445 0.313 3.851 0.855 8.563 1.039 9.658 -14.026 0.059-13.942-0.431-36.432-0.219 0.397-13.065 1.519-40.587-1.77-48.975 -7.75-19.678-44.052-31.323-33.378-62.632 -9.689 13.094-4.59 24.13 1.678 31.309 35.12 44.05 24.852 49.003 26.454 81.047 11.177 0.333 30.093 0.525 48.263-0.105C121.536 179.735 127.328 181.371 146.702 161.628zM39.184 142.011c-1.385-4.846 8.584-15.692 5.366-30.735C43.886 121.43 38.638 129.205 36 138c-3.999 33.884 27.286 39.376 14 74 0-13-2.667-19.437-7.667-31.437C42.333 196.563 49 207 41 223c0 0 2.761-11.765 0.26-17.418C32.879 180.272 39.439 170.276 33 154c-2.838-7.69-8.246-14.15-10.878-27.926 0.677 19.739 10.59 29.425 9.958 46.216 -0.663 12.739-1.207 13.817 1.268 22.173 6.55 22.107-3.539 20.229-0.849 47.579 12.221-0.525 22.025-0.014 33.847 0.527 2.261-24.406 5.03-40.444-7.662-60.172C51.814 171.72 37.453 160.703 39.184 142.011zM45 38c-4.149 20.744-5.556 42.857-18.478 58.357 0.366 3.807 0.713 6.488 0.837 7.762 -0.066 0.136-0.124 0.275-0.188 0.411C51.195 67.57 41.09 47.743 50 28c2-5 6.231-8.566 11-14C52.915 20.828 47 27 45 38zM166.623 102.836C155.162 84.076 155.692 61.634 148 38c-4.507-13.846-24.446-39.649-48.506-6.168 11.159-14.396 23.65-15.006 31.307-10.431 6.19 3.699 10.544 10.145 13.544 17.145 7.068 18.138 5.753 34.787 13.753 52.787 5 12 12.048 22.146 12.416 32.828 -0.332 4.575-3.198 15.689-4.698 19.253 0.479-1.376 6.27-12.165 6.27-18.4C172.085 118.144 170.466 109.127 166.623 102.836zM71.522 9.661c3.306-2.748 25.504-5.422 29.751 11.058C98.289 4.859 78.927 5.073 71.522 9.661zM135.429 8.581c3.49 2.642 2.081 1.447-0.513-0.514 -13.694-8.515-27.51-1.497-33.308 12.366C109.649 3.393 126.768 2.02 135.429 8.581zM147.768 15.763c-17.909-25.073-41.461-16.292-47.154-2.327C108.07-2.146 131.988-5.355 147.768 15.763zM47.118 21.915c-2.079 4.494 4.73-15.523 28.092-20.133 8.363-1.692 19.382-0.871 24.746 6.221C91.351-4.505 59.979-4.11 47.118 21.915zM134.716 12.859c1.24 0.864 2.13 1.626 2.078 1.583 -0.177-0.117-1.063-1.067-2.619-2.098 -11.543-7.674-29.75 1.124-33.899 15.082C105.102 13.747 123.645 5.512 134.716 12.859zM65.39 15.566c-3.443 2.883 4.383-2.277 6.732-2.839 8.25-2.126 24.014-0.522 28.82 11.981C96.429 10.93 77.129 7.13 65.39 15.566z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5983",
    d: "M54.287 8.395c-6.063 5.795-8.245 8.121-12.733 15.896C29.969 42.645 29.465 95.483 30.12 75.647 31.003 46.753 33.226 26.926 54.287 8.395zM40.166 46.282c-1.19 10.81 2.133-9.666 3.979-14.112C51.075 15.805 71.717-1.981 91.025 6.798c3.802 1.736 6.471 3.731 7.692 4.555C71.922-9.195 43.586 15.053 40.166 46.282zM140.025 11.352c4.61 4.55 8.293 8.722 8.248 8.671 -3.867-3.539-21.245-34.352-47.079-3.221C113.365 3.41 126.815-1.016 140.025 11.352zM91.268 18.114c5.95 4.151 11.459 11.672 10.709 10.672 -0.251-0.291-1.608-2.192-3.735-4.794C75.559-3.612 50 28.843 47.748 53.002 51.44 28.64 73.278 5.713 91.268 18.114zM148.446 35.102c0.914 2.425 1.39 3.932 1.306 3.63 -0.112-0.292-0.599-2.129-1.518-4.706 -7.781-22.254-29.125-27.144-48.288-4.222C119.501 8.442 139.361 12.269 148.446 35.102zM170.729 89.177c-0.008-0.391 0.217-2.754 0.27-6.182 0.46-22.099-4.53-58.257-22.219-71.904C171.765 31.294 170.628 90.434 170.729 89.177zM160.594 109.636c1.141 1.432 1.838 2.295 1.702 2.122 -6.983-11.994-4.544 1.486-14.992-43.759C151.208 88.03 150.813 97.418 160.594 109.636zM40.224 110.197c-3.71 3.778-2.039 2.239 0.691-0.536C55.243 92.089 52.19 85.149 56.037 63.719 52.939 77.874 52.532 97.469 40.224 110.197zM80.217 24.943c1.441-0.43 2.318-0.692 2.144-0.644 -4.026 1.411-20.332 4.076-24.18 27.199C61.569 36.735 70.158 28.113 80.217 24.943zM143.451 47.042c2.782 8.476-1.829-8.357-4.675-13.598 -5.338-10.289-12.488-12.038-23.153-11.645C133.024 21.025 137.857 30.72 143.451 47.042zM34.274 152.301c2.071 11.298 11.409 25.639 15.081 38.07 1.789 5.938 1.875 6.194-0.112-1.306 -11.232-35.413-21.715-39.51-10.232-69.374C39.011 119.691 30.189 136.554 34.274 152.301zM148.784 189.284c-0.385 2.617-0.607 4.203-0.555 3.89 9.005-39.146 13.987-26.598 11.758-65.936C160.009 171.216 154.996 151.983 148.784 189.284zM46.041 133.496c-8.804 20.717 5.362 28.95 22.507 53.013 3.892 6.425 2.585 4.246 1.648 2.489 -11.499-21.461-31.094-34.2-23.91-53.677 2.383-6.427 3.979-9.329 3.182-22.331C49.611 121.966 49.23 125.986 46.041 133.496zM52.428 119.592c-0.092 12.744-6.549 21.745 6.856 35.309 4.074 3.177-2.931-3.353-4.056-5.359 -2.187-3.878-3.819-8.571-3.37-13.059 0.683-13.909 1.296-1.389 0.912-29.999C52.413 116.792 52.728 110.031 52.428 119.592zM142.67 147.298c-1.671 2.148-4.705 4.313-5.604 6.149 -0.214 0.387 0.542-0.853 1.744-1.979 17.557-16.844 13.72-27.795 16.996-34.761C152.473 123.786 154.94 131.114 142.67 147.298zM126.529 187.542c-2.762 11.25-1.063 15.187-1.063 15.187 -0.185-1-0.322-1.582-0.322-3.37 2.057-31.334 25.247-25.986 31.597-60.146C151.157 167.077 131.887 167.036 126.529 187.542z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath5984",
    d: "M171.429 103.136c12.069-85.836-28.95-117.955-66.649-108.561 -63.629-15.205-85.202 40.694-77.51 109.5 -2.854 5.875-4.629 12.232-5.31 18.601 -2.671 2.329-6.03 4.794-7.03 5.43 2.281-0.256 4.492-0.737 6.75-1.4 -0.454 12.987 3.396 20.927 6.94 29.32 6.294 14.887 0.154 21.277 3.39 34.07 1.24 4.85 3.11 9.63 3.55 14.64 0.946 10.766-5.545 16.426-3.15 37.41 0.08 0 0.15-0.01 0.23-0.01 24.692-0.967 13.033-0.165 29.72 0.439 62.103 2.413 88.897-1.46 106.34-1.46 -12.259-39.767-0.309-49.433 3.61-63.05 3.343-11.656-3.539-17.892-3.11-27.43C170.279 131.121 182.242 124.247 171.429 103.136zM69.579 161.266c-11.588-2.079-16.382-8.37-21.42-19.061 -0.284-5.823 1.921-12.104 2.96-17.87 1.044-5.75 0.401-10.896-0.69-22.729 1.12-2.35 2.09-4.77 2.94-7.24 1.57 6.54 3.01 13.15 3.04 19.83C56.463 128.817 50.079 147.932 69.579 161.266zM21.699 126.226c-1.71 0.529-3.46 0.96-5.23 1.27 41.837-27.209 31.729-67.088 39.07-85.77 7.243-18.434 27.63-33.995 44.1-9.15 -0.06 0.08-0.109 0.15-0.16 0.23 -17.355-18.325-36.108 8.93-40.729 31.36 -4.49 21.877-6.914 51.458-35.12 61.41C23.629 125.575 21.699 126.205 21.699 126.226zM32.619 241.855c-0.543-9.458-0.846-11.33 0.73-18.64 1.28-5.961 3.59-12.12 3.23-18.271 -0.39-6.41-3.11-12.39-3.89-18.74 -0.75-6.14 0.5-12.31 0.53-18.46 0.082-12.213-10.172-20.935-9.61-41.63 8.104-2.688 15.358-7.616 20.94-14.84 0.917 21.249-5.573 19.928-6.48 31.84 -1.511 20.052 22.174 35.669 27.74 56.09 1.939 7.062 2.03 35.213 1.99 42.561C42.492 241.322 58.322 240.284 32.619 241.855zM67.999 241.766c1.762-47.609-0.21-49.127-16.54-70.601 -22.601-29.594-7.548-34.703-6.54-50.26 0.21-3.27 0-6.56-0.21-9.84 2.15-2.82 3.97-5.86 5.51-9.05 0.795 13.27 0.928 13.425 0.83 15.92 -0.627 17.156-14.775 28.272 12.29 53.859 21.941 20.76 20.976 18.661 21.51 70.03C79.229 241.865 73.609 241.865 67.999 241.766zM85.059 241.825c0.35-11.354 1.576-40.352-1.78-48.91 -8.071-20.492-33.704-27.098-35.08-49.83 0.323 1 3.402 7.811 6.93 11.45 4.472 4.623 9.446 6.313 15.75 7.25 -17.932-13.084-14.028-28.113-13.65-42.38 0.263-9.843-1.635-17.335-3.74-25.39 4.287-12.413 4.894-24.4 7.4-33.84 5.711-21.558 22.336-43.879 38.589-27.22 0.006-0.017 0.2-0.286 0.21-0.3 0.008 0.011 0.188 0.291 0.19 0.3 13.404-16.837 29.143-4.305 37.7 17.34 11.029 27.882 1.583 37.684 13.29 55.6 0.491 11.79 1.402 25.005-13.83 42.95 -3.366 3.96-8.398 7.835-12 9.92 15.66-0.846 25.939-14.893 31.14-29.75 -15.514 57.917-43.439 15.318-35.93 103.479 0.343 4.205 0.894 8.792 1.021 9.55C109.791 242.117 111.782 241.719 85.059 241.825zM163.389 147.476c7.729-35.545-14.471-31.226-17.31-59.59 -0.996-10.411-0.63-29.001-12.86-48.65 -8.754-14.108-21.634-20.468-33.27-6.5 -0.04-0.08-0.09-0.16-0.141-0.24 15.769-21.402 42.415-19.527 49.341 26.27 4.381 29.034 5.438 27.162 15.17 47.38C168.679 115.133 174.634 126.9 163.389 147.476zM151.329 106.596c2.058 3.087 4.326 5.995 6.521 9.05 0 16.35-13.219 39.914-30.75 42.47 2.52-1.54 4.96-3.229 7.09-5.25C150.003 137.833 152.699 124.613 151.329 106.596zM167.939 156.695c1.3 5.5 3.699 10.57 3.729 16.32 -1.432 16.422-17.601 23.629-3.31 67.67 -9.831-0.523-19.654 0.533-37.141 1.149 -0.459-25.169-2.177-31.864-0.949-42.59 2.851-25.063 24.016-23.109 27.159-56.189 -4.017 34.862-28.503 30.377-29.029 61.109 -0.033 2.001 2.4 37.353 2.43 37.681 -2.771 0.093-6.599 0.199-9.37 0.199 -7.985-81.762 13.702-65.904 27.891-91.109 4.94-8.745 8.701-22.552 8.76-34.92 8.21 11.655 7.685 17.531 4.77 32.819 5.384-8.491 9.791-22.53 6.51-32.88 -1.094-4.394-4.797-11.869-6.25-14.88 -10.84-22.439-8.965-23.64-13-45.33 -7.404-40.292-33.264-47.161-50.39-23.33 -17.552-27.954-45.346-8.197-49.08 25.4 -1.354 12.346-0.255 38.468-26.65 63.02 1.906-14.99 8.729-22.372 13.75-34.22 12.649-29.735 1.814-50.492 18.65-67.33C38.122 37.494 51 59.408 34.099 91.476c-1.94 3.67-4.1 7.24-6 10.939 -5.854-64.179 16.384-121.011 75.59-107.03 40.783-10.329 64.18 25.442 67.6 67.79 1.471 18.212-0.248 34.59-0.54 38.77 -2.87-4.89-6.31-9.47-8.34-14.81 -11.876-31.337-1.556-52.06-19.32-67.28 18.119 16.345 6.485 41.9 19.79 71.61 2.613 4.897 5.803 9.391 8.16 14.36C180.63 126.046 163.44 137.618 167.939 156.695z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single-move",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single",
    transform: "matrix(0.9499997000000001,0,0,0.9499997000000001,5.000112207219303,4.3502797788902114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6005",
    d: "M143.62 100.1c-2.36 2.2-6.23 3.04-13.56 3.04 -9.78 0-16.18-1.09-20.41-9.51 -3.29-6.54-4.62-13.56-3.02-15.98 2.21-3.34 8.57-5.61 15.67-6.28C134.63 77.23 143.29 88.98 143.62 100.1zM72.01 71.17c-7.64 0.21-15.09 2.35-18.27 7.05 -2.18 3.21-1.69 12.55-0.22 16.94 2 5.99 5.07 7.98 16.42 7.98 9.78 0 16.18-1.09 20.41-9.51 0.42-0.84 0.81-1.69 1.17-2.54C88.29 82.95 81.16 75.43 72.01 71.17z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6006",
    d: "M146.48 95.17c-0.71 2.12-1.56 3.73-2.86 4.94 -0.33-11.12-8.99-22.87-21.33-28.74 9.37-0.89 19.99 0.99 23.97 6.86C148.44 81.44 147.95 90.77 146.48 95.17zM93.38 77.65c-2.79-4.23-12.22-6.73-21.37-6.47 9.16 4.25 16.28 11.77 19.52 19.92C93.94 85.36 94.77 79.76 93.38 77.65z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6007",
    d: "M151.79 73.61c-10.18-5.46-36.14-7.01-45.5 0.15 -0.8 0.47-4.23-0.53-6.29-0.53 -1.95 0-5.42 1.05-6.29 0.53 -9.36-7.16-35.32-5.61-45.5-0.15 -1.46 0.79-1.62 4.51-0.35 5.08 0.91 0.41 1.51 0.98 1.46 1.98C49 86.29 50.55 93.59 51.23 95.6c0.87 2.59 2.44 7.41 9.29 8.6 5.83 1.01 16.43 1.48 21.94-0.17 9.99-2.98 14.24-18.04 14.42-23.17l0.01 0.02c0.4-1.8 5.82-1.8 6.23 0l0.01-0.02c0.17 5.13 4.43 20.19 14.42 23.17 5.51 1.65 16.11 1.18 21.94 0.17 6.85-1.19 8.42-6.01 9.29-8.6 0.68-2.02 2.23-9.31 1.92-14.93 -0.05-1 0.56-1.57 1.46-1.98C153.41 78.12 153.25 74.4 151.79 73.61zM81.41 101.36c-5.06 1.51-14.32 1.61-19.71 0.67 -4.54-0.79-6.44-3.26-7.7-7.03 -1.48-4.4-1.87-13.51 0.16-16.5 6.76-9.98 33.87-8.05 38.8-0.58C95.16 81.27 90.89 98.53 81.41 101.36zM146 95.01c-1.26 3.77-3.17 6.24-7.7 7.03 -5.39 0.94-14.65 0.84-19.71-0.67 -9.48-2.83-13.75-20.09-11.55-23.44 4.93-7.47 32.04-9.4 38.8 0.58C147.87 81.49 147.48 90.61 146 95.01z",
    fill: "#2c2c2c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath6008",
    d: "M118.58 101.32c2.79 0.83 6.86 1.24 10.85 1.27 -12.54 1.22-15.39-3.4-17.12-5.16 -3.52-3.59-5.69-8.95-5.85-16.65C106.49 86.86 110.76 98.99 118.58 101.32zM93.69 73.72c-9.36-7.16-35.32-5.62-45.5-0.15C71.43 67.05 84.93 70.42 93.69 73.72zM61.68 102c-4.54-0.79-6.44-3.26-7.7-7.03 -1.32-3.93-1.77-11.62-0.4-15.35 -1.83 4.22-1.12 12.39 0.26 16.5 1.6 4.8 4.54 7.18 17.34 6.46C67.71 102.65 64.25 102.44 61.68 102zM152.97 76.3c-0.04-1.13-0.45-2.32-1.2-2.73 -9.98-5.36-35.14-6.94-44.93-0.25C120 68.05 138.97 67.31 152.97 76.3z",
    fill: "#3b3b3b",
    strokeWidth: "none",
    opacity: 1
  }))))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1052",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1053",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    fontSize: "10px",
    textAnchor: "start",
    fontWeight: 400,
    anchor: "start",
    fill: "#333333",
    x: 51.518646240234375,
    y: 182.6396725177765,
    style: {
      display: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1054",
    dy: 13,
    x: 51.518646240234375
  }, "Created on Xavatar.io")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarAh);
export default __webpack_public_path__ + "static/media/AvatarAH.521eee7ac462fbf38c15afe8b816d0fd.svg";
export { ForwardRef as ReactComponent };